import { register } from "async-ops";
import { callMvcApi } from "../../../../../call-web-api";
import { getDefaultOptions } from "../../../../../utils/fetch";

export const GET_CURATED_CPT_CODE_LIST =
  "GET_CURATED_CPT_CODE_LIST";

export const service = async (data) => {
  const options: object = {
    url: `/Api/lookup/GetCodeLookup`,
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_CURATED_CPT_CODE_LIST, service, mock);
